<template>
  <div class="BonusRound">
    <top-page-title>Бонус игра за AUDI A3 2.0 FSI</top-page-title>

    <section class="section bg-grey-lightest py-12">
      <div class="container text-center leading-relaxed lg:w-3/4 mx-auto">
        <h2 class="text-3xl mb-6 ">
          Бонус Играта на МПС Експерт приключи!
        </h2>
        <img src="@/assets/images/sections/bonus-round-car.png" alt="" class="my-6 lg:max-w-3/5">
      </div>
    </section>
    <random-round-winner-section
      :winner="winner"
      :rest="rest"
    />
    <section class="section bg-white py-12 leading-relaxed border-dark-red border-t-4 text-center">
      <div class="container">
        <p class="my-4">Бонус Играта на МПС Експерт достига до теб с медийното партньорство на <a
          href="http://dizzyriders.bg"
          target="_blank"
          class="underline"
        >DizzyRiders.bg</a></p>
        <p class="text-center my-4">
          <a href="http://dizzyriders.bg" target="_blank"><img src="@/assets/images/sections/dizzyriders.png" alt=""></a>
        </p>
      </div>
    </section>
    <background-section
      id="play-round-section"
      image="sections/next_rounds.jpg"
      class="section bg-grey-lightest pt-10 border-dark-red border-t-4"
    >
      <div class="container flex justify-center flex-wrap">
        <div class="lg:w-3/5">
          <img
            class="-mt-l lg:max-w-none lg:float-right"
            src="@/assets/images/sections/next-round-audi.png"
            width="650"
            alt=""
          >
        </div>
        <div class="lg:w-2/5 flex flex-col lg:flex-row -mx-8 justify-center">
          <div class="mb-10 lg:mb-0 mx-8 px-4">
            <fancy-heading title="Участвай" subtitle="в надпреварата" />
            <div class="leading-relaxed">
              Играй и за това невероятно запазено <router-link :to="{ name: 'round', params: {id: 3} }" class="text-red">Q7 Quattro (4L) 3.0 TDI
              S-line</router-link>. <br>
              Кой е най-добрият? <a href="https://www.instagram.com/explore/tags/mpsexpert/" target="_blank" class="underline">#mpsexpert</a>
            </div>
            <div class="text-center mt-4">
              <router-link :to="{ name: 'round', params: {id: 3} }" class="button is-orange is-filled">Научи повече</router-link>
            </div>
          </div>
        </div>
      </div>
    </background-section>
  </div>
</template>

<script>
import Register from '@/views/Register'
import RandomRoundWinnerSection from '@/views/RandomRoundWinnerSection'

/**
 * @module BonusRound
 */
export default {
  name: 'BonusRound',
  components: { RandomRoundWinnerSection, Register },
  head () {
    return {
      title: 'Бонус игра за Audi A3 2.0 FSI',
      meta: [
        // Open Graph / Facebook
        { property: 'og:type', content: 'website' },
        { property: 'og:url', content: window.location.href },
        { property: 'og:title', content: 'Бонус игра за Audi A3 2.0 FSI - МПС Ескперт' },
        { property: 'og:image', content: require('@/assets/images/sections/bonus-round-car.png') },

        // Twitter
        { property: 'twitter:card', content: 'summary_large_image' },
        { property: 'twitter:url', content: window.location.href },
        { property: 'twitter:title', content: 'Бонус игра за Audi A3 2.0 FSI - МПС Ескперт' },
        { property: 'twitter:image', content: require('@/assets/images/sections/bonus-round-car.png') }
      ]
    }
  },
  data () {
    return {
      winner: {
        avatar: { full: 'https://api.mpsexpert.bg/uploads/avatars/441/2cefa3d0d1e263b3ee1e473391b9b4e6.jpeg' },
        full_name: 'Петър Иванов',
        registration_date: '2020-06-15 13:23:07'
      },
      rest: [
        { full_name: 'Живко Желязков', registration_date: '2020-05-29 19:02:00' },
        { full_name: 'Ренета Стамова', registration_date: '2020-06-09 15:25:31' },
      ]
    }
  }
}
</script>

<style lang='scss'>
@import '~utils';

</style>
